// components
import LoadingScreen from '../components/loading-screen';
//
import { Roles } from '../types/User';
import { useUserContext } from './useUserContext';
// ----------------------------------------------------------------------

type RolesGuardProps = {
  children: React.ReactNode;
  roles: (
    | Roles.professional
    | Roles.user
    | Roles.admin
    | Roles.organization_admin
    | Roles.organization_owner
  )[];
  onPermissionDenied?: () => React.ReactNode;
};

export default function RolesGuard({
  children,
  roles,
  onPermissionDenied,
}: RolesGuardProps) {
  const {
    isLoading,
    isProfessionalRole,
    isUserRole,
    data,
    isAdminRole,
    isOrganizationAdminRole,
    isOrganizationOwnerRole,
  } = useUserContext();

  // Check if user has any of the required roles
  const hasRequiredRole =
    (isProfessionalRole && roles.includes(Roles.professional)) ||
    (isUserRole && roles.includes(Roles.user)) ||
    (isAdminRole && roles.includes(Roles.admin)) ||
    (isOrganizationAdminRole && roles.includes(Roles.organization_admin)) ||
    (isOrganizationOwnerRole && roles.includes(Roles.organization_owner));

  if (!data || isLoading) {
    return <LoadingScreen />;
  }

  // If user has any of the required roles, render children
  if (hasRequiredRole) {
    return <>{children}</>;
  }

  // If permission is denied and we have a callback, render its result
  if (onPermissionDenied) {
    return <>{onPermissionDenied()}</>;
  }

  // If no permission and no callback, render nothing
  return null;
}
